// provide enum valies tp match the XpoSnackBarStatus type
export enum NotificationMessageStatus {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warn = 'warn',
}
